import { TFunction } from "i18next";
import React from "react";
import { NoDataComponent } from "../../../../../ds";
import { ActionType, DataResponse, IProduct } from "../../../business";
import { ProductFactory } from "../../interfaces/factories";
import { ProductList } from "../screens/components/product-list/product-list.component.tsx";

export class ProductListFactoryImpl implements ProductFactory {
    create(data: DataResponse | undefined, handleShowModal: (product: IProduct, action: ActionType) => void, translate: TFunction<"product", undefined>): React.ReactElement {
        if (data && data.success && data.response && Array.isArray(data.response)) {
            if (data.response.length === 0) {
                return <p>{translate('noProduct')}</p>
            }
            return <ProductList data={data.response} handleShowModal={handleShowModal} />
        }
        return <NoDataComponent />
    }
}